import type { Difficulty } from '../generators/math/types';

export type Phase = 'warmup' | 'guide' | 'challenge' | 'exam';

export const PHASE_MULT: Record<Phase, number> = {
  warmup: 0,
  guide: 0.5,
  challenge: 1.0,
  exam: 1.2,
};

export const XP_BASE_BY_DIFFICULTY: Record<Difficulty, number> = {
  1: 10,
  2: 15,
  3: 20,
};

const WRONG_TRIAL_REWARD = 2;

export interface AnswerInput {
  correct: boolean;
  difficulty: Difficulty;
  phase: Phase;
  timedOut?: boolean; // present for clarity; treated identically to correct=false here
}

export interface AnswerResult {
  xpAwarded: number;
  combo: number;
}

function comboMultiplier(combo: number, phase: Phase): number {
  if (phase === 'exam' && combo >= 10) return 3.0;
  if (combo >= 5) return 2.0;
  if (combo >= 3) return 1.5;
  return 1.0;
}

export class QuizEngine {
  private combo = 0;

  recordAnswer(input: AnswerInput): AnswerResult {
    if (!input.correct) {
      this.combo = 0;
      return { xpAwarded: WRONG_TRIAL_REWARD, combo: 0 };
    }
    this.combo += 1;
    const base = XP_BASE_BY_DIFFICULTY[input.difficulty];
    const phaseMult = PHASE_MULT[input.phase];
    const comboMult = comboMultiplier(this.combo, input.phase);
    const xp = base * comboMult * phaseMult;
    return { xpAwarded: xp, combo: this.combo };
  }
}
